import React, { Fragment } from 'react';
import type { FC, PropsWithChildren } from 'react';

import { Modal } from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import ModalButtons from '../../components/Modal/ModalButtons';
import ShareFileSkeleton from '../../Skeletons/ShareFileSkeleton';
import SelectBox from '../../components/Modal/SelectBox';
import { DownloadModalState } from './DownloadFileModal';
import { IFolderRes } from '../../hooks/folders/index.type';

export type IcutModalStates = PropsWithChildren<{
  folder: { value: string; error: string };
}>;

type CutFileModalProps = PropsWithChildren<{
  loading: boolean;
  cutFileModal: DownloadModalState;
  folders?: IFolderRes;
  cutFilePasswordInput: IcutModalStates;
  setCutFilePasswordInput: React.Dispatch<React.SetStateAction<IcutModalStates>>;
  onCloseModal?: () => void;
  handleCutFile?: (event: React.FormEvent<HTMLFormElement>) => void;
}>;

const CutFileModal: FC<CutFileModalProps> = props => {
  return (
    <Modal show={props.cutFileModal.status}>
      {props.loading ? (
        <ShareFileSkeleton fileProtected={props.cutFileModal.data?.protected} />
      ) : (
        props.cutFileModal.data && (
          <Fragment>
            <ModalHeading heading={`Move ${props.cutFileModal.data.name}?`} />
            <ModalForm style={{ marginBottom: '2.5rem' }} onSubmit={props.handleCutFile}>
              <InputsSection style={{ width: '34rem' }}>
                <SelectBox
                  label='Select destination folder'
                  value={props.cutFilePasswordInput.folder.value}
                  onChange={event => {
                    props.setCutFilePasswordInput(prevVal => ({ ...prevVal, folder: { value: event.target.value, error: '' } }));
                  }}
                  errorMessage={props.cutFilePasswordInput.folder.error}
                >
                  <option value=''>Select destination folder</option>
                  {props.folders && props.folders.data.data.length > 0 ? (
                    props.folders.data.data.map(folder => (
                      <Fragment key={folder._id}>
                        <option value={folder._id} style={{ fontWeight: '800' }}>
                          {folder.name}
                        </option>
                        {folder.childFolders &&
                          folder.childFolders.length > 0 &&
                          folder.childFolders.map(childFolder => (
                            <option value={childFolder._id} key={childFolder._id}>
                              {childFolder.name}
                            </option>
                          ))}
                      </Fragment>
                    ))
                  ) : (
                    <option value=''>No folders created</option>
                  )}
                </SelectBox>
              </InputsSection>
              <ModalButtons submitButtonLabel='Move File' cancelButtonLabel='Cancel' onCancel={props.onCloseModal} />
            </ModalForm>
          </Fragment>
        )
      )}
    </Modal>
  );
};

export default CutFileModal;
